<template>
  <BaseWidget
    :class="[widget.type, { active: messageType === 'annual' }]"
    :loading="loading"
    :widget-options="widgetMenuOptions"
    content-only
    @refresh-data="refreshData"
    v-on="$listeners"
  >
    <template v-slot:content>
      <portal to="dash-modal">
        <ReferralInfoModal v-if="showModal" @close-modal="showModal = false" :messageType="messageType" />
      </portal>

      <div v-if="!loading" class="referral-content-wrap" :class="{ active: messageType === 'annual' }">
        <div class="title">
          <img
            v-if="messageType === 'annual'"
            class="referral-crown"
            src="/static/img/crown.svg"
            alt="referral discount active"
          />
          <span class="title-text">
            {{ title }}
            <span v-if="messageType === 'annual'" class="referral-active-label">
              {{ $gettext('Referral discount active') }}
            </span>
          </span>
        </div>

        <div v-if="messageType !== 'annual'" style="z-index: 10">
          <GekkoButton
            @click="showModal = true"
            :text="$gettext('See how it works')"
            variant="white"
            class="w-100"
            size="sm"
          />
        </div>

        <img
          v-if="messageType !== 'annual'"
          class="referral-decoration"
          src="/static/img/tag-label.svg"
          alt="referral discount icon"
        />
      </div>
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseWidget from '@/components/dashboard/widgets/BaseWidget'
import GekkoButton from '@/components/GekkoButton'
import ReferralInfoModal from '@/components/dashboard/ui/ReferralInfoModal'

export default {
  name: 'referral-fee-widget',
  components: { BaseWidget, GekkoButton, ReferralInfoModal },
  props: {
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      showModal: false,
      messageType: 'basic', // basic, monthly, annual
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.messageType = 'basic'
      if (this.activePlan && this.activePlan.planline_set && this.activePlan.planline_set.length > 0) {
        const durationMonths = parseInt(this.activePlan.planline_set[0].duration_months, 10)
        const billingSettingsRenewalMonths = parseInt(this.billingSettings.renewal_months, 10)

        if (durationMonths <= 1 && billingSettingsRenewalMonths <= 1) {
          this.messageType = 'monthly'
        } else if (durationMonths > 1 || billingSettingsRenewalMonths > 1) {
          this.messageType = 'annual'
        }
      }
      this.loading = false
    },
    refreshData() {
      this.loading = true
      this.getData()
    },
  },
  computed: {
    ...mapGetters({
      activePlan: 'subscriptionStore/getActivePlan',
      billingSettings: 'subscriptionStore/getBillingSettings',
    }),
    title() {
      if (this.messageType === 'annual') return this.$gettext('Congratulations!')
      return this.$gettext('You are eligible for a referral discount!')
    },
    widgetMenuOptions() {
      if (this.loading) return []
      return [{ name: this.$gettext('Remove From Dashboard'), icon: 'icon-remove', event: { name: 'custom-remove' } }]
    },
  },
}
</script>

<style lang="scss">
.widget-wrapper.referral-fee {
  background: linear-gradient(40deg, #1b8d72, #22ac8a);
  .referral-content-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    .title {
      position: relative;
      z-index: 10;
      font-size: 22px;
      line-height: 1.2;
      text-align: center;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      .referral-crown {
        width: 50px;
        height: 50px;
      }

      .title-text {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .referral-active-label {
        font-size: 16px;
        color: $colorBrand;
      }
    }
    &.active {
      .title {
        font-size: 24px;
      }
    }
  }
  .ui-dashboard-menu-dropdown:not(.show) .widget-dropdown-toggle,
  .widget-content {
    background: transparent;
    color: white;
    h3 {
      margin-top: 0;
    }
    .referral-decoration {
      pointer-events: none;
      height: 100% !important;
      width: auto !important;
      margin: 0 auto;
      position: absolute;
      bottom: 0;
      right: 0;
      opacity: 0.1;
    }
  }

  &.active {
    background: white;
    .widget-content {
      color: #333;
    }
  }
}
</style>
